import script from "./ConvDrawer.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConvDrawer.vue?vue&type=script&setup=true&lang=ts"

import "./ConvDrawer.vue?vue&type=style&index=0&id=6e284dcf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e284dcf"]])

export default __exports__